function updateHeaderArt() {
  document.querySelectorAll("[data-header-art-threshold]").forEach((header) => {
    const threshold = Number(header.dataset.headerArtThreshold || 30)
    header.classList.toggle("is-header-art-visible", window.scrollY >= threshold)
  })
}

let headerArtTicking = false

function requestHeaderArtUpdate() {
  if (headerArtTicking) return

  headerArtTicking = true
  window.requestAnimationFrame(() => {
    updateHeaderArt()
    headerArtTicking = false
  })
}

document.addEventListener("scroll", requestHeaderArtUpdate, { passive: true })
document.addEventListener("DOMContentLoaded", updateHeaderArt)
document.addEventListener("turbo:load", updateHeaderArt)

updateHeaderArt()
